<template>
  <div class="props-group">
    <el-form-item label="归档表" required>
      <el-select v-model="archive.tableId" @change="changeTable" filterable>
        <el-option v-if="showCurrentOption" :key="archive.defaultArchivedId" label="[当前表]" :value="archive.defaultArchivedId" />
        <el-option v-for="item in tableOptions" :key="item.id" :label="item | formatNew" :value="item.id" :disabled="getRelations.includes(item.id)"/>
      </el-select>
    </el-form-item>
    <el-form-item label="主表键" required>
      <el-select v-model="archive.primaryKey" filterable>
        <el-option v-for="item in primaryColumn" :key="item.id" :label="item | formatNew" :value="item.id"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="从表键" required>
      <el-select v-model="archive.foreignKey" filterable>
        <el-option v-for="item in foreignKeyOptions" :key="item.id" :label="item | formatNew" :value="item.id"></el-option>
        <el-option key="create" label="[创建外键]" value="create" />
      </el-select>
    </el-form-item>
  </div>
</template>
<script>
import {UUID} from '@/plugins/common'
export default {
  name: 'attr-archived-table',
  props: ['component'],
  inject: ['formService'],
  data () {
    const archive = this.component.archive

    return {
      archive,
      foreignKeyOptions: []
    }
  },
  mounted () {
    if (!this.archive.primaryKey) {
      this.archive.primaryKey = this.primaryTable.getPrimaryKey().id
    }
    this.foreignKeyOptions = this.formService.getColumns(this.archive.tableId)
  },
  methods: {
    changeTable () {
      if (this.archive.tableId !== this.archive.defaultArchivedId) {
        this.formService.loadTable(this.archive.tableId).then(() => {
          this.foreignKeyOptions = this.formService.getColumns(this.archive.tableId)
        })
      } else {
        this.foreignKeyOptions = this.formService.getColumns(this.archive.tableId)
      }
      this.archive.foreignKey = 'create'
      this.archive.relationId = UUID.create()
    }
  },
  computed: {
    tableOptions () {
      return this.formService.getAllTable()
    },
    showCurrentOption () {
      return !this.tableOptions.some(m => m.id === this.archive.defaultArchivedId)
    },
    primaryColumn () {
      let parentComponent = this.formService.getParentComponent(this.component)
      const tableId = this.formService.getParentArchived(parentComponent).tableId
      return this.formService.getColumns(tableId)
    },
    getRelations () {
      let tableIds = []
      this.formService.schema.relations.forEach(m => {
        tableIds.push(m.primaryTable)
      })
      return tableIds
    }
  },
  filters: {
    formatNew: (item) => item.isNew ? `${item.name}*` : item.name
  }
}
</script>



// WEBPACK FOOTER //
// src/components/form/componentAttr/archived-table.vue